import { actions } from "react-redux-form";
import {
    getDebitorCatalogueUploadTypes,
    setDebitorCatalgueUploadError,
    DeitorCatalogueUploadModel
} from "../../../../constants/model-reducers/external/recharge/debitor-catalogue-upload.settings";
import { httpDownload, httpPost } from "../../../../utils/api.utils";

export const debitorCatalogueUploadFormInitialState = DeitorCatalogueUploadModel;

const defaultState = () => ({
    debitorCatalogueUploadTypeOptions: [],
    debitorCatalogueUploadError: false
});


const initialState = defaultState();

export const DebitorCatalogueUploadAction = {

    getDebitorCatalogueUploadTypes: () => async (dispatch, state) => {
        var res = await httpPost(`external/recharge/getDebitorUploadTypeList`);
        if (res.ok === false) {
            dispatch({
                type: setDebitorCatalgueUploadError,
                debitorCatalogueUploadError: false,
                debitorCatalogueUploadTypeOptions: []
            })
        } else {
            dispatch({
                type: getDebitorCatalogueUploadTypes,
                data: res
            });
        }
    },

    onDebitorCatalogueUploadTypeSelect: (model, value) => async (dispatch, state) => {
        const intValue = parseInt(value);

        dispatch(actions.change(model, value));
        dispatch(actions.change("debitorUploadForm.debitorCatalogueUploadTypeId", intValue))

    },

    postExecuteProcess: (UploadId) => () => {
        var url = 'external/adminupload/executePackage';

        httpPost(url, UploadId);
    },

    resetDebitorUploadForm: () => async (dispatch, state) => {
        dispatch(actions.reset('debitorUploadForm.debitorCatalogueUploadTypeId'));
    },

    downloadDebitorCatalogueUploadTemplate: (fileAttachmentModule, fileName) => async (dispatch, getState) => {
        const encodedFileName = encodeURIComponent(fileName);

        const dealName = sessionStorage.getItem('DealName');
        const newFileName = `ATEM ${dealName} - Debitor Catalogue Template.xlsx`;

        try {
            const response = await httpDownload(`common/fileAttachment/downloadFile/${fileAttachmentModule}/${encodedFileName}`);
            if (response.ok) {
                response.blob().then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, newFileName);
                    } else {
                        a.href = downloadUrl;
                        a.download = newFileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                });
            } else {
                dispatch({
                    type: setDebitorCatalgueUploadError,
                    debitorCatalogueUploadError: false,
                })
            }
        } catch (error) {
            dispatch({
                type: setDebitorCatalgueUploadError,
                debitorCatalogueUploadError: false,
            })
        }
    }

}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getDebitorCatalogueUploadTypes:
            return {
                ...state,
                debitorCatalogueUploadTypeOptions: action.data
            }
        case setDebitorCatalgueUploadError:
            return {
                ...state,
                debitorCatalogueUploadError: action.debitorCatalogueUploadError
            }
        default:
            return state
    }
}